import PropTypes from 'prop-types'

import useCsatNps from './useCsatNps.js'

/**
 * Leaf that owns the CSAT/NPS tracking state, so its re-renders (useCsat's mount
 * flag, the eligibility flag) never re-render the page that hosts it.
 */
const CsatNpsTracker = ({adId, isDisabled}) => {
  useCsatNps({adId, isDisabled})
  return null
}

CsatNpsTracker.displayName = 'CsatNpsTracker'

CsatNpsTracker.propTypes = {
  /** Id of the viewed ad; omitted on a list view */
  adId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Skips counting and triggering, as on an ad preview */
  isDisabled: PropTypes.bool
}

export default CsatNpsTracker
